import createClient from "openapi-fetch";
import type { paths } from "./schema";
export const portalClient = createClient<paths>({
	baseUrl: import.meta.env.VITE_SUBSTRATE_PORTAL_API_BASE ?? "",
	credentials: "include",
});
let unauthorized = () => {};
export function setPortalUnauthorizedHandler(handler: () => void) {
	unauthorized = handler;
}
portalClient.use({
	async onResponse({ response }) {
		if (response.status === 401) unauthorized();
		return response;
	},
});
export class PortalApiError extends Error {
	constructor(
		readonly code: string,
		message: string,
		readonly retryAfterSeconds?: number,
		readonly reason?: "noOrganization" | "noKey" | "providerRefused",
	) {
		super(message);
	}
}
export async function portalApiError(response: Response) {
	let body: {
		error?: { code?: string; message?: string; reason?: "noOrganization" | "noKey" | "providerRefused" };
	} = {};
	try {
		body = await response.json();
	} catch {
		/* static fallback */
	}
	return new PortalApiError(
		body.error?.code ?? "portalRequestFailed",
		body.error?.message ?? "The request could not be completed",
		response.headers.get("Retry-After") ? Number(response.headers.get("Retry-After")) : undefined,
		body.error?.reason,
	);
}
export async function portalFetch<T>(path: string, init: RequestInit = {}) {
	const response = await fetch(`${import.meta.env.VITE_SUBSTRATE_PORTAL_API_BASE ?? ""}${path}`, {
		...init,
		credentials: "include",
		headers: { ...(init.body ? { "Content-Type": "application/json" } : {}), ...init.headers },
	});
	if (response.status === 401) unauthorized();
	if (!response.ok) throw await portalApiError(response);
	if (response.status === 204) return undefined as T;
	const body = (await response.json()) as { data: T };
	return body.data;
}
